import React from 'react'
import type { ChangeEventHandler, FocusEventHandler, HTMLAttributes, RefObject } from 'react'
import * as S from './Radio.styled'

export type RadioProps = {
  name?: string
  value?: string
  checked?: boolean
  disabled?: boolean
  readOnly?: boolean
  tabIndex?: number
  inputRef?: RefObject<HTMLInputElement>
  onChange?: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
} & HTMLAttributes<HTMLInputElement>

export const Radio = ({
  name,
  value,
  checked,
  disabled,
  readOnly,
  tabIndex,
  inputRef,
  onChange,
  onBlur,
  ...rest
}: RadioProps) => (
  <S.Container>
    <S.Input
      type="radio"
      name={name}
      value={value}
      ref={inputRef}
      tabIndex={tabIndex}
      checked={checked}
      disabled={disabled}
      readOnly={readOnly}
      onChange={onChange}
      onBlur={onBlur}
      {...rest}
    />
    <S.Radio />
  </S.Container>
)
